import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChatStateService {
  private readonly footerItemsSubject = new BehaviorSubject<any[]>([]);
  footerItems$ = this.footerItemsSubject.asObservable();

  private readonly apiStatusSubject = new BehaviorSubject<string>('');
  apiStatus$ = this.apiStatusSubject.asObservable();

  setFooterItems(items: any[]) {
    this.footerItemsSubject.next(items);
  }

  getFooterItemsSnapshot(): any[] {
    return this.footerItemsSubject.value;
  }

  setApiStatus(status: string) {
    this.apiStatusSubject.next(status);
  }
}
